<div class="ImageContainer Flexbox Justify--center">
  @if(!isSharing() && activeBarItem()?.key !== 'favorites') {
    <div class="HiddenDesktop TopRightContainer Flexbox">
      <button mat-icon-button (click)="openShareSection()"><mat-icon>ios_share</mat-icon></button>
    </div>
  }

  @if (wasModelSuccess()) {
    <app-main-image [isComparing]="activeBarItem()?.key === 'favorites'" [isSharing]="isSharing()" [canViewStyleImages]="styleImages().length > 0" (modelCreated)="modelCreated($event)" (viewStyleImagesClicked)="openStyleImageGallery(styleImages()[0])"></app-main-image>
  } @else {
    <div class="Flexbox Justify--center Align--center UnavailableMessage">
      <h3>Preview not available</h3>
    </div>
  }

  @if (!isSharing() && activeBarItem()?.key !== 'favorites') {
    <div class="HiddenDesktop BottomRightContainer Flexbox Flexbox--column Align--flex-end Gap--smaller">
      <button mat-icon-button class="HiddenDesktop BookmarkButton" (click)="toggleBookmark()">
        <mat-icon class="ThemeColorPrimary">@if (!isBookmarkKeyInBookmarks(bookmarkKey())) {favorite_outline} @else {favorite}</mat-icon>
      </button>
    </div>
  }

  @if (!isSharing() && !isRetailerMode()) {
    <div class="BottomLeftContainer">
      <button class="ChatButton" mat-flat-button (click)="openChat()"><mat-icon>chat_bubble</mat-icon></button>
    </div>
  }
</div>
